/* ============================================================
   Insole Finder — insole-finder.js
   Place in: assets/insole-finder.js
   Load via: {{ 'insole-finder.js' | asset_url | script_tag }}
   ============================================================ */

(function () {

  /* ── Results layout (same card size + alignment as the collection page) ─────────
     On phones the finder's section + card padding left the results cards ~146px wide (the collection page
     gives ~172px), so the text wrapped a lot and the cards looked very tall. The results panel now uses
     the same width as a collection grid, and a single last card sits on the left like on collection pages. */
  (function () {
    if (document.getElementById('if-results-layout')) return;
    var st = document.createElement('style');
    st.id = 'if-results-layout';
    st.textContent =
      '@media (max-width: 56rem) {' +
        '#if-results .if-results__grid > div:last-child:nth-child(odd) { grid-column: auto; justify-self: stretch; width: auto; }' +
      '}' +
      '@media (max-width: 37.5rem) {' +
        '#insole-finder.insole-finder { padding-left: 0.75rem !important; padding-right: 0.75rem !important; }' +
        '#if-results { margin-left: -1rem; margin-right: -1rem; }' +
        '#if-results .if-results__grid { gap: 0.75rem; }' +
      '}';
    document.head.appendChild(st);
  })();

  /* ── Product logic maps ─────────────────────────────────────
     Based on: India-Insole-Questionaire.xlsx
     DIRECT: Q1 answer goes straight to results (skip Q2 + Q3)
     RESULTS: [complaint][shoe] → array of product handles
     Sheet rule: Women's low-medium heels ALWAYS show Versa + Catwalk, whatever was chosen in Q1
     (enforced in ifResolveHandles below).
     NOTE: real product handles are footlogics-sensi and footlogics-34pro
  ──────────────────────────────────────────────────────────── */

  var HEELS = ['footlogics-versa', 'footlogics-catwalk'];

  var DIRECT = {
    performance:  { handles: ['footlogics-sports', 'footlogics-football', 'footlogics-performance'] },
    high:         { handles: ['footlogics-performance'] },
    diabetic:     { handles: ['footlogics-sensi'] },
    severs:       { handles: ['footlogics-kids-full-length', 'footlogics-kids-34-length'] },
    'child-flat': { handles: ['footlogics-kids-full-length', 'footlogics-kids-34-length'] }
  };

  var RESULTS = {
    comfort: {
      lace:   ['footlogics-comfort', 'footlogics-premium'],
      slip:   ['footlogics-casual', 'footlogics-34pro'],
      sports: ['footlogics-sports', 'footlogics-football', 'footlogics-performance'],
      heels:  HEELS
    },
    plantar: {
      lace:   ['footlogics-plantar-fasciitis'],
      slip:   ['footlogics-casual', 'footlogics-34pro'],
      sports: ['footlogics-sports', 'footlogics-football', 'footlogics-performance'],
      heels:  HEELS
    },
    achilles: {
      lace:   ['footlogics-plantar-fasciitis'],
      slip:   ['footlogics-casual', 'footlogics-34pro'],
      sports: ['footlogics-sports', 'footlogics-football', 'footlogics-performance'],
      heels:  HEELS
    },
    meta: {
      lace:   ['footlogics-meta-full-length'],
      slip:   ['footlogics-metatarsalgia', 'footlogics-versa'],
      sports: ['footlogics-sports', 'footlogics-football', 'footlogics-performance'],
      heels:  HEELS
    },
    neuroma: {
      lace:   ['footlogics-meta-full-length'],
      slip:   ['footlogics-metatarsalgia', 'footlogics-versa'],
      sports: ['footlogics-sports', 'footlogics-football', 'footlogics-performance'],
      heels:  HEELS
    },
    flat: {
      lace:   ['footlogics-comfort', 'footlogics-premium'],
      slip:   ['footlogics-casual', 'footlogics-34pro'],
      sports: ['footlogics-sports', 'footlogics-football', 'footlogics-performance'],
      heels:  HEELS
    },
    tired: {
      lace:   ['footlogics-sensi', 'footlogics-workmate'],
      slip:   ['footlogics-casual', 'footlogics-34pro'],
      sports: ['footlogics-sports', 'footlogics-football', 'footlogics-performance'],
      heels:  HEELS
    },
    shin: {
      /* Excel note: Shin Splints only applies to Sports and Football */
      lace:   ['footlogics-sports', 'footlogics-football'],
      slip:   ['footlogics-sports', 'footlogics-football'],
      sports: ['footlogics-sports', 'footlogics-football'],
      heels:  HEELS
    },
    knee: {
      /* Excel note: no Catwalk alone for knee */
      lace:   ['footlogics-comfort', 'footlogics-casual'],
      slip:   ['footlogics-casual', 'footlogics-34pro'],
      sports: ['footlogics-sports', 'footlogics-football', 'footlogics-performance'],
      heels:  HEELS
    },
    back: {
      /* Excel note: no Catwalk alone for back */
      lace:   ['footlogics-comfort', 'footlogics-casual'],
      slip:   ['footlogics-casual', 'footlogics-34pro'],
      sports: ['footlogics-sports', 'footlogics-football', 'footlogics-performance'],
      heels:  HEELS
    }
  };

  /* Fallback descriptions for inline card (used when pool clone unavailable) */
  var DESCRIPTIONS = {
    'footlogics-plantar-fasciitis':       'For plantar fasciitis, heel pain & heel spurs',
    'footlogics-metatarsalgia':           'For ball of foot pain & Morton’s Neuroma',
    'footlogics-meta-full-length':        'For ball of foot pain & Morton’s Neuroma',
    'footlogics-sensi':                   'For diabetic foot, sensitive feet & everyday comfort',
    'footlogics-comfort':                 'For flat feet, fallen arches, knee & back pain',
    'footlogics-premium':                 'For flat feet, fallen arches & premium support',
    'footlogics-34pro':                   'For flat feet in slip-on shoes & loafers',
    'footlogics-casual':                  'For flat feet, fallen arches & heel pain',
    'footlogics-versa':                   'For flat feet, plantar fasciitis & heels',
    'footlogics-catwalk':                 'For women’s heels, tired feet & ball of foot pain',
    'footlogics-workmate':                'For flat feet & tired aching feet at work',
    'footlogics-sports':                  'For sports, running, shin splints & plantar fasciitis',
    'footlogics-football':                'For football, running & flat feet',
    'footlogics-performance':             'For high arches, sports performance & running',
    'footlogics-kids-34-length':          'For children’s flat feet & fallen arches',
    'footlogics-kids-full-length':        'For children’s flat feet, fallen arches & Sever’s disease'
  };

  /* ── Result title labels ────────────────────────────────────── */
  var LABELS = {
    plantar:      'for Plantar Fasciitis',
    achilles:     'for Achilles Tendonitis',
    meta:         'for Ball of Foot Pain',
    neuroma:      'for Morton’s Neuroma',
    flat:         'for Flat Feet',
    high:         'for High Arches',
    tired:        'for Tired Aching Feet',
    shin:         'for Shin Splints',
    knee:         'for Knee Pain',
    back:         'for Low Back Pain',
    comfort:      'for Everyday Comfort',
    performance:  'for Sports & Running',
    diabetic:     'for Diabetic Foot',
    severs:       'for Children',
    'child-flat': 'for Children'
  };

  /* ── State ──────────────────────────────────────────────────── */
  var state = { q1: '', q2: '', shoe: '' };

  /* ── DOM refs ───────────────────────────────────────────────── */
  var q1El         = document.getElementById('if-q1');
  var q2El         = document.getElementById('if-q2');
  var q3Section    = document.getElementById('if-q3-section');
  var q3Hint       = document.getElementById('if-q3-hint');
  var submitBtn    = document.getElementById('if-submit');
  var q2Dropdown   = document.getElementById('if-q2-dropdown');
  var q2Trigger    = document.getElementById('if-q2-trigger');
  var q2Menu       = document.getElementById('if-q2-menu');
  var q2Label      = document.getElementById('if-q2-label');
  var q2LabelHover = document.getElementById('if-q2-label-hover');
  var q1Dropdown   = document.getElementById('if-q1-dropdown');
  var q1Trigger    = document.getElementById('if-q1-trigger');
  var q1Menu       = document.getElementById('if-q1-menu');
  var q1Label      = document.getElementById('if-q1-label');

  /* ── Q2 helpers ─────────────────────────────────────────────── */
  function ifResetQ2() {
    q2El.value = '';
    if (q2Dropdown) q2Dropdown.classList.add('if-dropdown--disabled');
    ifCloseActivityDropdown();
    if (q2Label)      { q2Label.textContent = 'Activity...'; q2Label.classList.add('is-placeholder'); }
    if (q2LabelHover)   q2LabelHover.textContent = 'Activity...';
    if (q2Menu) q2Menu.querySelectorAll('.if-dropdown__item').forEach(function (b) { b.classList.remove('is-selected'); });
    state.q2 = '';
  }

  function ifEnableQ2Dropdown() {
    if (q2Dropdown) q2Dropdown.classList.remove('if-dropdown--disabled');
  }

  /* ── Q2 dropdown open / close ───────────────────────────────── */
  window.ifToggleDropdownQ2 = function () {
    if (!q2Dropdown || q2Dropdown.classList.contains('if-dropdown--disabled')) return;
    var isOpen = q2Menu && q2Menu.classList.contains('is-open');
    isOpen ? ifCloseActivityDropdown() : ifOpenActivityDropdown();
  };

  function ifOpenActivityDropdown() {
    if (!q2Menu) return;
    q2Menu.classList.add('is-open');
    if (q2Trigger)   { q2Trigger.classList.add('is-open'); q2Trigger.setAttribute('aria-expanded', 'true'); }
    if (q2Dropdown)    q2Dropdown.setAttribute('aria-expanded', 'true');
  }

  function ifCloseActivityDropdown() {
    if (!q2Menu) return;
    q2Menu.classList.remove('is-open');
    if (q2Trigger)   { q2Trigger.classList.remove('is-open'); q2Trigger.setAttribute('aria-expanded', 'false'); }
    if (q2Dropdown)    q2Dropdown.setAttribute('aria-expanded', 'false');
  }

  window.ifSelectActivity = function (val, label) {
    q2El.value = val;
    if (q2Label)      { q2Label.textContent = label; q2Label.classList.remove('is-placeholder'); }
    if (q2LabelHover)   q2LabelHover.textContent = label;
    if (q2Menu) q2Menu.querySelectorAll('.if-dropdown__item').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.getAttribute('data-value') === val);
    });
    ifCloseActivityDropdown();
    ifHandleQ2(val);
  };

  /* ── Q1 dropdown open / close ───────────────────────────────── */
  window.ifToggleDropdown = function () {
    if (!q1Menu) return;
    q1Menu.classList.contains('is-open') ? ifCloseComplaintDropdown() : ifOpenComplaintDropdown();
  };

  function ifOpenComplaintDropdown() {
    if (!q1Menu) return;
    q1Menu.classList.add('is-open');
    if (q1Trigger)   { q1Trigger.classList.add('is-open'); q1Trigger.setAttribute('aria-expanded', 'true'); }
    if (q1Dropdown)    q1Dropdown.setAttribute('aria-expanded', 'true');
  }

  function ifCloseComplaintDropdown() {
    if (!q1Menu) return;
    q1Menu.classList.remove('is-open');
    if (q1Trigger)   { q1Trigger.classList.remove('is-open'); q1Trigger.setAttribute('aria-expanded', 'false'); }
    if (q1Dropdown)    q1Dropdown.setAttribute('aria-expanded', 'false');
  }

  window.ifSelectComplaint = function (val, label) {
    q1El.value = val;
    if (q1Label) { q1Label.textContent = label; q1Label.classList.remove('is-placeholder'); }
    var q1LabelHover = document.getElementById('if-q1-label-hover');
    if (q1LabelHover) q1LabelHover.textContent = label;
    if (q1Menu) q1Menu.querySelectorAll('.if-dropdown__item').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.getAttribute('data-value') === val);
    });
    ifCloseComplaintDropdown();
    ifHandleQ1(val);
  };

  /* ── Q1 handler ─────────────────────────────────────────────── */
  window.ifHandleQ1 = function (val) {
    state.q1 = val;
    state.shoe = '';
    document.querySelectorAll('input[name="if-shoe"]').forEach(function (r) { r.checked = false; });
    ifHideResults();

    if (!val) {
      ifResetQ2(); ifHideQ3(); ifSetSubmit(false);
      return;
    }

    if (DIRECT[val]) {
      /* Direct exit — skip Q2 + Q3 */
      ifResetQ2(); ifHideQ3(); ifSetSubmit(true);
      return;
    }

    ifEnableQ2Dropdown();
    ifHideQ3();
    ifSetSubmit(false);
  };

  /* ── Q2 handler ─────────────────────────────────────────────── */
  window.ifHandleQ2 = function (val) {
    state.q2 = val;
    state.shoe = '';
    document.querySelectorAll('input[name="if-shoe"]').forEach(function (r) { r.checked = false; });
    ifHideResults();

    if (!val) { ifHideQ3(); ifSetSubmit(false); return; }

    if (val === 'sports') {
      /* Sports → direct to sports products, skip Q3 */
      ifHideQ3(); ifSetSubmit(true);
      return;
    }

    ifShowQ3();
    ifSetSubmit(false);
  };

  /* ── Q3 shoe handler ────────────────────────────────────────── */
  window.ifHandleShoe = function (val) {
    state.shoe = val;
    ifHideResults();
    ifSetSubmit(true);
  };

  /* ── Submit ─────────────────────────────────────────────────── */
  window.ifSubmit = function () {
    var handles = ifResolveHandles();
    if (!handles || !handles.length) return;
    ifShowResults(handles);
  };

  function ifResolveHandles() {
    if (DIRECT[state.q1])       return DIRECT[state.q1].handles;
    if (state.q2 === 'sports')  return ['footlogics-sports', 'footlogics-football', 'footlogics-performance'];
    /* Sheet rule: women's low-medium heels always show Versa + Catwalk, whatever was chosen in Q1 */
    if (state.shoe === 'heels') return HEELS;
    if (RESULTS[state.q1] && state.shoe) return RESULTS[state.q1][state.shoe];
    return ['footlogics-comfort'];
  }

  /* ── Warm up the images for the answer the visitor has just given ──────────
     The pool is hidden and its images are lazy, so they would only start downloading when the results
     appear. As soon as the answers are complete (before they press the button) the matching products'
     images are told to load, so the results show instantly. Only those few products are fetched - the
     rest of the pool is left alone so the page itself stays fast. */
  function ifWarm() {
    var pool = document.getElementById('if-product-pool');
    if (!pool) return;
    var handles = ifResolveHandles() || [];
    handles.forEach(function (handle) {
      var source = pool.querySelector('[data-handle="' + handle + '"]');
      if (!source) return;
      source.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    });
  }

  /* ── Show results ───────────────────────────────────────────── */
  function ifShowResults(handles) {
    var grid  = document.getElementById('if-results-grid');
    var panel = document.getElementById('if-results');
    var title = document.getElementById('if-results-title');
    var pool  = document.getElementById('if-product-pool');
    if (!grid || !panel) return;

    if (title) title.textContent = 'We recommend ' + (LABELS[state.q1] || 'the following insoles');

    grid.innerHTML = '';

    var frag = document.createDocumentFragment();

    handles.forEach(function (handle) {
      var source = pool && pool.querySelector('[data-handle="' + handle + '"]');

      if (source) {
        /* ✅ Clone the pre-rendered product-card from the Liquid pool.
           The wrapper div carries data-handle AND product-card-container--fluid
           so container queries fire identically to collection pages. */
        var clone = source.cloneNode(true);
        clone.removeAttribute('aria-hidden');
        /* Also clear hidden state on any inner product-card element */
        var innerCard = clone.querySelector('product-card');
        if (innerCard) innerCard.removeAttribute('aria-hidden');
        clone.querySelectorAll('img').forEach(function (img) {
          img.loading = 'eager';
          img.decoding = 'async';
        });
        frag.appendChild(clone);
      } else {
        /* ⚠️ Fallback: product handle not found in pool (not in assigned collection).
           Check Theme Editor → Insole Finder → Insoles collection includes this product. */
        console.warn('[insole-finder] handle not found in pool — using JSON fallback:', handle);
        fetch('/products/' + handle + '.json')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data || !data.product) return;
            var p     = data.product;
            var img   = p.images && p.images[0] ? p.images[0].src : '';
            /* Shopify storefront /products/handle.json returns price as a decimal string
               in the store's currency unit (e.g. "1990.00" = ₹1990). Do NOT divide by 100.
               Use parseFloat to handle decimal strings correctly. */
            var price = p.variants && p.variants[0]
              ? ('₹' + parseFloat(p.variants[0].price).toLocaleString('en-IN'))
              : '';
            var desc  = DESCRIPTIONS[handle] || '';
            var wrap  = document.createElement('div');
            /* NOTE: outer element is <a>, so CTA must be <span> — nested <a> is invalid HTML */
            wrap.innerHTML =
              '<a href="/products/' + p.handle + '" class="if-card">' +
                '<div class="if-card__img-wrap">' +
                  (img ? '<img src="' + img + '" alt="' + p.title + '" class="if-card__img" loading="lazy">' : '') +
                '</div>' +
                '<div class="if-card__body">' +
                  '<span class="if-card__title">' + p.title + '</span>' +
                  '<span class="if-card__desc">' + desc + '</span>' +
                  (price ? '<span class="if-card__price">' + price + '</span>' : '') +
                '</div>' +
                '<span class="if-card__cta">View Product</span>' +
              '</a>';
            grid.appendChild(wrap);
          })
          .catch(function () { /* handle not in store — skip silently */ });
      }
    });

    /* all cards go in together (one layout pass) */
    grid.appendChild(frag);

    panel.classList.add('is-visible');

    /* Grid is a plain CSS grid — no custom element to notify */

    requestAnimationFrame(function () {
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  /* ── Hide results ───────────────────────────────────────────── */
  function ifHideResults() {
    var panel = document.getElementById('if-results');
    var grid  = document.getElementById('if-results-grid');
    if (panel) panel.classList.remove('is-visible');
    if (grid)  grid.innerHTML = '';
  }

  /* ── Reset everything ───────────────────────────────────────── */
  window.ifReset = function () {
    q1El.value = '';
    if (q1Label) { q1Label.textContent = 'Foot complaint or goal...'; q1Label.classList.add('is-placeholder'); }
    var q1LabelHover = document.getElementById('if-q1-label-hover');
    if (q1LabelHover) q1LabelHover.textContent = 'Foot complaint or goal...';
    if (q1Menu) q1Menu.querySelectorAll('.if-dropdown__item').forEach(function (b) { b.classList.remove('is-selected'); });
    ifCloseComplaintDropdown();
    ifHandleQ1('');
    var section = document.getElementById('insole-finder');
    if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* ── Q3 show / hide ─────────────────────────────────────────── */
  function ifShowQ3() {
    if (q3Section) q3Section.style.display = '';
    if (q3Hint)    q3Hint.style.display = 'none';
    if (window.innerWidth < 600) {
      setTimeout(function () {
        if (q3Section) q3Section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 80);
    }
  }

  function ifHideQ3() {
    if (q3Section) q3Section.style.display = 'none';
    if (q3Hint)    q3Hint.style.display = '';
    state.shoe = '';
    document.querySelectorAll('input[name="if-shoe"]').forEach(function (r) { r.checked = false; });
  }

  function ifSetSubmit(enabled) {
    if (submitBtn) submitBtn.disabled = !enabled;
    if (enabled) ifWarm();
  }

  /* ── Popup ──────────────────────────────────────────────────── */
  window.ifOpenPopup = function () {
  var overlay = document.getElementById('if-popup');
  if (overlay && overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);   // trapping ancestor 
  }
  if (overlay) overlay.classList.add('is-open');
  document.body.style.overflow = 'hidden';
};

  window.ifClosePopup = function () {
    var overlay = document.getElementById('if-popup');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  window.ifClosePopupOutside = function (e) {
    if (e.target === document.getElementById('if-popup')) ifClosePopup();
  };

  /* ── Global: close dropdowns on outside click / Escape ─────── */
  document.addEventListener('click', function (e) {
    if (q1Dropdown && !q1Dropdown.contains(e.target)) ifCloseComplaintDropdown();
    if (q2Dropdown && !q2Dropdown.contains(e.target)) ifCloseActivityDropdown();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      ifCloseComplaintDropdown();
      ifCloseActivityDropdown();
      ifClosePopup();
    }
  });

})();